import React from 'react';
import { IModalConfig } from '../../components/customModal';

interface IModalContext {
	modalConfig: IModalConfig;
	setModalConfig: React.Dispatch<
		React.SetStateAction<{
			isOpen: boolean;
			content?: React.ReactChild;
			header?: React.ReactChild;
			footer?: React.ReactChild;
		}>
	>;
}

const ModalContext = React.createContext<IModalContext>({} as IModalContext);

export default ModalContext;
